import React from 'react';

interface TextProps {
  text: string;
  x?: number;
  y?: number;
  color: string;
  size: number;
  weight?: string;
  opacity?: number;
  align: 'left' | 'center' | 'right';
  transform?: string;
}

export default function Text({
  text,
  x = 0,
  y = 0,
  color,
  size,
  weight,
  align,
  opacity,
  transform,
}: TextProps) {
  let textAnchor: string | undefined = undefined;
  if (align === 'center') textAnchor = 'middle';
  else if (align === 'left') textAnchor = 'start';
  else if (align === 'right') textAnchor = 'end';
  return (
    <text
      opacity={opacity}
      x={x}
      y={y + size * 0.35}
      textAnchor={textAnchor}
      fontSize={size}
      fontWeight={weight}
      fill={color}
      children={text}
      transform={transform}
    />
  );
}
